/* rf-quiz.js — "Find Your REFORME" product-finder quiz (P3-8; loaded ONLY by
   sections/rf-quiz.liquid via a section-scoped script tag, never theme.liquid).

   ROUTING (CLAUDE.md §4 — tags are the ONLY routing truth; algorithm logged in
   DECISIONS 2026-07-14): every candidate <li data-rf-quiz-cand> is SERVER-
   rendered with its live §4 tags (data-tags) and min price in cents
   (data-price). Scoring per candidate:
     goal tag match      +8   (dominates all other axes combined: 2+1+2 = 5 < 8)
     scenario tag match  +2
     budget fit          +2   (answered cap && price <= cap; soft — never excludes)
     level tag match     +1   ("Neither" answer carries no tag and scores nothing)
   Sort: score desc via stable Array.prototype.sort → ties keep DOM order =
   template block_order = the §4 best-sellers roster order (merchandising truth).
   Primary = rank 1 (full card: quote + add-ons + CTAs); runners-up = ranks 2-3
   (compact card). JS only ranks and reveals — it never writes product data.

   KLAVIYO (B4 canonical wiring; endpoint shape VERIFIED against Klaviyo's
   OpenAPI spec 2026-07-14, qa/2026-07-14-p38-selfcheck/facts-audit.md §6):
   POST https://a.klaviyo.com/client/subscriptions?company_id=<public site id>
   with required header revision: 2026-04-15, JSON:API body (custom_source
   "quiz", nested profile resource w/ properties = answers + recommendation,
   list relationship). Public key ONLY — client endpoints never see a private
   key (B4 law). Success = 202 (empty body). The email step is optional and
   results are NEVER gated: skip always works, errors still reveal results.

   A11Y LAWS honored: click/tap paths NEVER call .focus() (P5-7) — the ONLY
   script focus is the sanctioned rescue when the just-activated control is
   hidden by the transition (Next→email, back→step-0, submit/skip→results,
   retake); roving tabindex + Arrow/Home/End per the rf-workouts-library chip
   idiom; progress line is aria-live; no timers/intervals (isConnected law N/A);
   scrolling respects prefers-reduced-motion. */
(function () {
  'use strict';

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  var KLAVIYO_REVISION = '2026-04-15'; /* current revision per Klaviyo OpenAPI (verified 2026-07-14) */
  var CUSTOM_SOURCE = 'quiz'; /* B4 canonical — fixed, not a setting */
  var WEIGHTS = { goal: 8, scenario: 2, budget: 2, level: 1 };

  function initQuiz(root) {
    var app = root.querySelector('[data-rf-quiz-app]');
    if (!app) return;

    var steps = Array.prototype.slice.call(app.querySelectorAll('[data-rf-quiz-step]'));
    var questionSteps = steps.filter(function (s) { return s.getAttribute('data-rf-quiz-step') !== 'email'; });
    var emailStep = app.querySelector('[data-rf-quiz-step="email"]');
    var results = app.querySelector('[data-rf-quiz-results]');
    var nav = app.querySelector('[data-rf-quiz-nav]');
    var nextBtn = app.querySelector('[data-rf-quiz-next]');
    var progressText = app.querySelector('[data-rf-quiz-progress]');
    var progressWrap = app.querySelector('[data-rf-quiz-progresswrap]');
    var bar = app.querySelector('[data-rf-quiz-bar]');
    var form = app.querySelector('[data-rf-quiz-form]');
    var formStatus = app.querySelector('[data-rf-quiz-formstatus]');
    var note = app.querySelector('[data-rf-quiz-note]');
    var recap = app.querySelector('[data-rf-quiz-recap]');
    var cands = Array.prototype.slice.call(app.querySelectorAll('[data-rf-quiz-cand]'));
    if (!questionSteps.length || !cands.length || !nextBtn) return;

    /* JS is alive — reveal the app (noscript links stay in <noscript>) */
    root.classList.remove('rf-qz--nojs');

    var total = questionSteps.length;
    var idx = 0; /* index into questionSteps; total = email step; total+1 = results */
    /* answers[axis] = { tag|cap, label } */
    var answers = {};
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var submitting = false;

    function axisOf(step) { return step.getAttribute('data-rf-quiz-step'); }

    /* --- sanctioned focus rescue (P5-7 exception): only fires when the
       control the user just activated got hidden by the transition --- */
    function rescueFocus(pane) {
      var active = document.activeElement;
      var lost = !active || active === document.body || !active.isConnected ||
                 active.offsetParent === null;
      if (!lost) return;
      var heading = pane.querySelector('.rf-qz__q, .rf-qz__results-title');
      if (!heading) return;
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }

    function scrollCardIntoView() {
      var top = root.getBoundingClientRect().top;
      if (top < 0) {
        root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    }

    function show(pane) {
      questionSteps.forEach(function (s) { s.hidden = s !== pane; });
      if (emailStep) emailStep.hidden = pane !== emailStep;
      results.hidden = pane !== results;
      nav.hidden = questionSteps.indexOf(pane) === -1;
    }

    function updateNav() {
      var step = questionSteps[idx];
      var backBtn = nav.querySelector('[data-rf-quiz-back]');
      if (backBtn) backBtn.hidden = idx === 0;
      nextBtn.disabled = !answers[axisOf(step)];
    }

    function setProgress(label, fraction) {
      if (progressText) progressText.textContent = label;
      if (bar) bar.style.width = Math.round(fraction * 100) + '%';
    }

    function showQuestion(i, isBoot) {
      idx = i;
      var step = questionSteps[idx];
      show(step);
      if (progressWrap) progressWrap.hidden = false;
      setProgress('Question ' + (idx + 1) + ' of ' + total, (idx + 1) / (total + 1));
      updateNav();
      /* Blake item 19.1 (fix round 2026-07-14): the initial render is NOT a
         step transition — nothing was activated, so the rescue must not steal
         page-load focus into mid-page. It stays for genuine transitions. */
      if (!isBoot) rescueFocus(step);
      scrollCardIntoView();
    }

    function showEmail() {
      if (!emailStep || !form) { reveal(); return; }
      show(emailStep);
      if (progressWrap) progressWrap.hidden = false;
      setProgress('Last step, optional', total / (total + 1));
      rescueFocus(emailStep);
      scrollCardIntoView();
    }

    /* ---------- scoring ---------- */
    function rank() {
      var scored = cands.map(function (el, domIndex) {
        var tags = (el.getAttribute('data-tags') || '').split(',');
        var price = parseInt(el.getAttribute('data-price') || '0', 10);
        var score = 0;
        ['goal', 'scenario', 'level'].forEach(function (axis) {
          var a = answers[axis];
          if (a && a.tag && tags.indexOf(a.tag) !== -1) score += WEIGHTS[axis];
        });
        var b = answers.budget;
        if (b && b.cap && price > 0 && price <= b.cap) score += WEIGHTS.budget;
        return { el: el, score: score, domIndex: domIndex };
      });
      /* stable sort: ties keep DOM order = block_order = best-sellers roster */
      scored.sort(function (x, y) { return y.score - x.score; });
      return scored;
    }

    function reveal() {
      var ranked = rank();
      var flags = { primary: '', runner: '' };
      cands.forEach(function (el) {
        el.hidden = true;
        el.style.order = '';
        el.classList.remove('rf-qz__cand--primary', 'rf-qz__cand--runner');
      });
      ranked.slice(0, 3).forEach(function (entry, i) {
        var el = entry.el;
        var flag = el.querySelector('[data-rf-quiz-flag]');
        var info = el.querySelector('[data-rf-quiz-info]');
        el.hidden = false;
        el.style.order = i; /* grid order = rank (DOM stays in roster order) */
        el.classList.add(i === 0 ? 'rf-qz__cand--primary' : 'rf-qz__cand--runner');
        if (flag) {
          flag.textContent = i === 0 ? (root.getAttribute('data-flag-primary') || 'YOUR MATCH')
                                     : (root.getAttribute('data-flag-runner') || 'ALSO GREAT');
          flag.hidden = false;
        }
        if (info) info.hidden = i !== 0;
      });
      if (recap) {
        var picked = ['goal', 'scenario', 'level', 'budget'].map(function (axis) {
          return answers[axis] ? answers[axis].label : '';
        }).filter(Boolean);
        recap.textContent = picked.length ? 'Based on your answers: ' + picked.join(' · ') : '';
      }
      show(results);
      if (progressWrap) progressWrap.hidden = true;
      rescueFocus(results);
      scrollCardIntoView();
    }

    /* ---------- Klaviyo (results are NEVER gated on this) ---------- */
    function subscribe(email, done) {
      var company = (form.getAttribute('data-company') || '').trim();
      var list = (form.getAttribute('data-list') || '').trim();
      if (!company || !list) { done(false); return; }
      var ranked = rank();
      var props = {
        quiz_goal: answers.goal ? answers.goal.tag : '',
        quiz_scenario: answers.scenario ? answers.scenario.tag : '',
        quiz_level: answers.level && answers.level.tag ? answers.level.tag : 'neither',
        quiz_budget: answers.budget ? answers.budget.label : '',
        quiz_recommendation: ranked[0] ? ranked[0].el.getAttribute('data-title') : '',
        quiz_recommendation_handle: ranked[0] ? ranked[0].el.getAttribute('data-handle') : '',
        quiz_runners_up: ranked.slice(1, 3).map(function (e) {
          return e.el.getAttribute('data-title');
        }).join(' | ')
      };
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: CUSTOM_SOURCE,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: props,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };
      fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': KLAVIYO_REVISION
        },
        body: JSON.stringify(payload)
      }).then(function (r) {
        done(r.ok); /* 202 Accepted = success (empty body) */
      }).catch(function () {
        done(false);
      });
    }

    function setFormStatus(msg, isError) {
      if (!formStatus) return;
      formStatus.textContent = msg || '';
      formStatus.hidden = !msg;
      formStatus.classList.toggle('rf-qz__status--error', !!isError);
    }

    function setNote(msg, isError) {
      if (!note) return;
      note.textContent = msg || '';
      note.hidden = !msg;
      note.classList.toggle('rf-qz__status--error', !!isError);
    }

    /* ---------- chips: aria-pressed + roving tabindex (workouts idiom) ---------- */
    var rows = Array.prototype.slice.call(app.querySelectorAll('[data-rf-quiz-row]'));
    rows.forEach(function (row) {
      var step = row.closest('[data-rf-quiz-step]');
      var axis = step ? axisOf(step) : '';
      var chips = Array.prototype.slice.call(row.querySelectorAll('[data-rf-quiz-chip]'));
      chips.forEach(function (chip, i) {
        chip.tabIndex = i === 0 ? 0 : -1;
        chip.addEventListener('click', function () {
          /* select: single-choice per row. NO .focus() here (P5-7) — the tap
             already focused natively; just re-sync state + roving tabIndex. */
          chips.forEach(function (c, j) {
            c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
            c.tabIndex = j === i ? 0 : -1;
          });
          if (axis === 'budget') {
            answers.budget = {
              cap: parseInt(chip.getAttribute('data-cap') || '0', 10) || 0,
              label: chip.textContent.trim()
            };
          } else {
            answers[axis] = {
              tag: chip.getAttribute('data-tag') || '',
              label: chip.textContent.trim()
            };
          }
          updateNav();
        });
        chip.addEventListener('keydown', function (e) {
          /* explicit Enter/Space activation (ARIA toolbar convention). Native
             buttons also click on Enter/Space — the click handler is
             idempotent (single-select re-set), so a double fire is harmless;
             this covers environments whose key synthesis skips the default
             action (found in P3-8 harness verification). */
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            chip.click();
            return;
          }
          var to = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = (i + 1) % chips.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') to = (i - 1 + chips.length) % chips.length;
          else if (e.key === 'Home') to = 0;
          else if (e.key === 'End') to = chips.length - 1;
          if (to < 0) return;
          e.preventDefault();
          chips.forEach(function (c, j) { c.tabIndex = j === to ? 0 : -1; });
          chips[to].focus(); /* keyboard path — the ONLY sanctioned .focus() outside rescue */
        });
      });
    });

    /* ---------- nav ---------- */
    nextBtn.addEventListener('click', function () {
      if (!answers[axisOf(questionSteps[idx])]) return;
      if (idx + 1 < total) showQuestion(idx + 1);
      else showEmail();
    });

    /* back buttons exist in the question nav AND inside the email step */
    Array.prototype.forEach.call(app.querySelectorAll('[data-rf-quiz-back]'), function (backBtn) {
      backBtn.addEventListener('click', function () {
        var onEmail = emailStep && !emailStep.hidden;
        if (onEmail) showQuestion(total - 1);
        else if (idx > 0) showQuestion(idx - 1);
      });
    });

    /* ---------- email step ---------- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submitting) return; /* double-POST guard (P3-2 N-1 precedent) */
        var input = form.querySelector('input[type="email"]');
        var email = input ? input.value.trim() : '';
        var valid = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
                    (!input.checkValidity || input.checkValidity());
        if (!valid) {
          if (input) input.setAttribute('aria-invalid', 'true');
          setFormStatus(root.getAttribute('data-msg-invalid') || 'Please enter a valid email, or skip below.', true);
          return;
        }
        if (input) input.removeAttribute('aria-invalid');
        submitting = true;
        var submitBtn = form.querySelector('[data-rf-quiz-submit]');
        if (submitBtn) submitBtn.disabled = true;
        setFormStatus('');
        subscribe(email, function (ok) {
          submitting = false;
          if (submitBtn) submitBtn.disabled = false;
          /* results reveal on BOTH paths — never gated */
          setNote(ok ? (root.getAttribute('data-msg-success') || 'You’re on the list. Results below.')
                     : (root.getAttribute('data-msg-error') || 'Hmm, that didn’t go through. Your results are below anyway.'),
                  !ok);
          reveal();
        });
      });
    }
    var skipBtn = app.querySelector('[data-rf-quiz-skip]');
    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        setNote('');
        reveal();
      });
    }

    /* ---------- retake ---------- */
    var retakeBtn = app.querySelector('[data-rf-quiz-retake]');
    if (retakeBtn) {
      retakeBtn.addEventListener('click', function () {
        answers = {};
        setNote('');
        setFormStatus('');
        /* peer N1 (fix round): full reset re-homes each row's roving tabindex
           to chip[0] — a stale mid-row tab stop would misstate the reset. */
        Array.prototype.forEach.call(app.querySelectorAll('[data-rf-quiz-row]'), function (row) {
          Array.prototype.forEach.call(row.querySelectorAll('[data-rf-quiz-chip]'), function (c, j) {
            c.setAttribute('aria-pressed', 'false');
            c.tabIndex = j === 0 ? 0 : -1;
          });
        });
        showQuestion(0);
      });
    }

    showQuestion(0, true); /* boot render — no focus rescue (Blake 19.1) */
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rf-quiz]'), initQuiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
